(function () {
  'use strict';
  if (window.MilfiosMetragem) return;

  const config = JSON.parse(document.getElementById('milfios-metragem-config')?.textContent || '{}');
  const messages = config.messages || {};
  const root = window.Shopify?.routes?.root || '/';
  const transport = window.fetch.bind(window);
  const meterVariants = new Set();
  const controllers = new WeakMap();
  let queue = Promise.resolve();
  let pending = 0;
  let interactionLocks = 0;
  let notice;
  let dialog;

  const meters = (quantity) => String(Number((quantity / 5).toFixed(1)));
  const number = (value) => Number(String(value).replace(',', '.'));
  const fmt = (value) => value.toLocaleString('pt-BR', { maximumFractionDigits: 1 });
  const msg = (key) => messages[key] || messages.error || key;
  const meterItem = (item) => Object.hasOwn(item.properties || {}, 'Metragem') || meterVariants.has(String(item.variant_id));
  const totalFor = (cart, id) => cart.items.filter((item) => String(item.variant_id) === String(id)).reduce((sum, item) => sum + item.quantity, 0);
  const quantities = (cart) => JSON.stringify(cart.items.map((item) => [item.variant_id, item.key, item.quantity, item.final_line_price]));
  const limit = (stock) => stock.tracked && stock.policy === 'deny' ? Math.max(0, Number(stock.inventory)) : null;

  async function request(path, body) {
    const controller = new AbortController();
    const timer = setTimeout(() => controller.abort(), 15000);
    try {
      const response = await transport(path, {
        method: body === undefined ? 'GET' : 'POST',
        credentials: 'same-origin',
        cache: 'no-store',
        signal: controller.signal,
        headers: { Accept: body === undefined ? '*/*' : 'application/json', ...(body === undefined ? {} : { 'Content-Type': 'application/json' }) },
        ...(body === undefined ? {} : { body: JSON.stringify(body) }),
      });
      const data = await response.json();
      if (!response.ok && response.status !== 422) throw new Error(msg('error'));
      return { ok: response.ok, status: response.status, data };
    } finally {
      clearTimeout(timer);
    }
  }

  async function cart() {
    const result = await request(root + 'cart.js');
    if (!result.ok || !Array.isArray(result.data.items)) throw new Error(msg('error'));
    return result.data;
  }

  async function state() {
    const result = await request(root + 'cart?view=milfios-state&_=' + Date.now());
    if (!result.ok || result.data.version !== 2 || !Array.isArray(result.data.items)) throw new Error(msg('error'));
    if (result.data.items.some((item) => typeof item.metered !== 'boolean' || !item.key || !item.variant_id)) throw new Error(msg('error'));
    result.data.items.forEach((item) => { if (item.metered) meterVariants.add(String(item.variant_id)); });
    return result.data;
  }

  async function product(url, id) {
    const path = new URL(url, window.location.origin);
    if (path.origin !== window.location.origin) throw new Error(msg('error'));
    path.searchParams.set('variant', String(id));
    path.searchParams.set('view', 'milfios-state');
    path.searchParams.set('_', String(Date.now()));
    const result = await request(path.href);
    if (!result.ok || result.data.version !== 2 || String(result.data.variant_id) !== String(id)) throw new Error(msg('error'));
    if (typeof result.data.tracked !== 'boolean' || typeof result.data.available !== 'boolean' || !['deny', 'continue'].includes(result.data.policy)) throw new Error(msg('error'));
    const inventoryLimit = limit(result.data);
    if (inventoryLimit !== null && (typeof result.data.inventory !== 'number' || !Number.isSafeInteger(inventoryLimit))) throw new Error(msg('error'));
    return result.data;
  }

  function busy() {
    document.documentElement?.classList.toggle('milfios-metragem-busy', pending + interactionLocks > 0);
    document.dispatchEvent(new CustomEvent('milfios:busy', { detail: { pending } }));
  }

  function lock(value) {
    interactionLocks += value ? 1 : -1;
    busy();
  }

  function run(task) {
    pending += 1;
    busy();
    const result = queue.then(task);
    queue = result.catch(() => {});
    return result.finally(() => { pending -= 1; busy(); });
  }

  async function repair(current) {
    const maxAttempts = current.items.length * 3 + 10;
    for (let attempt = 0; attempt < maxAttempts; attempt += 1) {
      const stale = current.items.find((item) => meterItem(item) && number(item.properties?.Metragem) !== item.quantity / 5);
      if (!stale) return current;
      const result = await request(root + 'cart/change.js', {
        id: stale.key,
        quantity: stale.quantity,
        properties: { ...stale.properties, Metragem: meters(stale.quantity) },
      });
      const next = await cart();
      if (!result.ok && JSON.stringify(next.items) === JSON.stringify(current.items)) throw new Error(msg('error'));
      current = next;
    }
    throw new Error(msg('error'));
  }

  async function write(body) {
    let result;
    let failure;
    try { result = await request(root + 'cart/change.js', body); } catch (error) { failure = error; }
    const current = await repair(await cart());
    if (failure) throw failure;
    return { cart: current, adjusted: !result.ok };
  }

  async function add(options) {
    return run(async () => {
      const { variantId, url, units } = options;
      if (!Number.isSafeInteger(units) || units < 1) throw new Error(msg('minimum'));
      meterVariants.add(String(variantId));
      const [before, stock] = await Promise.all([cart(), product(url, variantId)]);
      const maximum = limit(stock);
      const previous = totalFor(before, variantId);
      if (!stock.available || (maximum !== null && previous + units > maximum)) {
        const error = new Error(msg('stock_changed'));
        error.stock = stock;
        error.cart = before;
        throw error;
      }
      const properties = options.properties || {};
      const others = (value) => JSON.stringify(Object.entries(value || {}).filter(([key]) => key !== 'Metragem').sort(([a], [b]) => a.localeCompare(b)));
      const existing = before.items.find((item) => String(item.variant_id) === String(variantId) && !item.selling_plan_allocation && others(item.properties) === others(properties));
      const desired = (existing?.quantity || 0) + units;
      if (desired < 5) throw new Error(msg('minimum'));
      let response;
      let failure;
      try {
        response = await request(root + (existing ? 'cart/change.js' : 'cart/add.js'), {
          ...(existing ? { id: existing.key } : { id: variantId }),
          quantity: desired,
          properties: { ...properties, ...(existing?.properties || {}), Metragem: meters(desired) },
        });
      } catch (error) { failure = error; }
      const current = await repair(await cart());
      if (failure) throw failure;
      const added = totalFor(current, variantId) - previous;
      return { cart: current, adjusted: !response.ok || added !== units, added };
    });
  }

  async function change(key, units) {
    return run(async () => {
      if (!Number.isSafeInteger(units) || (units > 0 && units < 5) || units < 0) throw new Error(msg('minimum'));
      await state();
      const before = await cart();
      const item = before.items.find((line) => line.key === key);
      if (!item) throw new Error(msg('review'));
      const result = await write({ id: item.key, quantity: units, properties: { ...item.properties, Metragem: meters(units) } });
      const accepted = result.cart.items.find((line) => line.key === key) || result.cart.items.find((line) => String(line.variant_id) === String(item.variant_id));
      result.adjusted ||= accepted?.quantity !== units && units !== 0;
      return result;
    });
  }

  async function check() {
    return run(async () => {
      const before = await cart();
      await state();
      let current = await cart();
      for (let attempt = 0; attempt < 4; attempt += 1) {
        const items = current.items.filter(meterItem);
        if (items.length) {
          if (!current.token || items.length > 250) throw new Error(msg('error'));
          const result = await request('/api/2026-07/graphql.json', {
            query: 'mutation MilfiosRevalidateCart($cartId:ID!,$lines:[CartLineUpdateInput!]!) { cartLinesUpdate(cartId:$cartId,lines:$lines) { cart { lines(first:250) { nodes { viewKey quantity attributes { key value } } pageInfo { hasNextPage } } } userErrors { code field message } warnings { code } } }',
            variables: {
              cartId: 'gid://shopify/Cart/' + current.token,
              lines: items.map((item) => ({
                viewKey: item.key,
                quantity: item.quantity,
                attributes: Object.entries({ ...item.properties, Metragem: meters(item.quantity) }).map(([key, value]) => ({ key, value: String(value) })),
              })),
            },
          });
          const payload = result.data.data?.cartLinesUpdate;
          const snapshot = payload?.cart?.lines;
          if (!result.ok || result.data.errors?.length || !Array.isArray(payload?.userErrors) || payload.userErrors.length || !Array.isArray(snapshot?.nodes) || snapshot.pageInfo?.hasNextPage !== false) throw new Error(msg('error'));
          current = await cart();
          if (current.items.some((item) => meterItem(item) && number(item.properties?.Metragem) !== item.quantity / 5)) {
            current = await repair(current);
            continue;
          }
          if (snapshot.nodes.length !== current.items.length || snapshot.nodes.some((line) => {
            const item = current.items.find((candidate) => candidate.key === line.viewKey);
            if (!item || item.quantity !== line.quantity) return true;
            return meterItem(item) && number(line.attributes?.find((attribute) => attribute.key === 'Metragem')?.value) !== line.quantity / 5;
          })) throw new Error(msg('review'));
        }
        const verified = await cart();
        if (JSON.stringify(verified.items) !== JSON.stringify(current.items)) throw new Error(msg('review'));
        return { cart: verified, adjusted: quantities(before) !== quantities(verified), belowMinimum: verified.items.some((item) => meterItem(item) && item.quantity < 5) };
      }
      throw new Error(msg('review'));
    });
  }

  async function reconcile() {
    return run(async () => { await state(); return repair(await cart()); });
  }

  function announce(current) {
    document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart: current } }));
    document.dispatchEvent(new CustomEvent('milfios:cart', { detail: { cart: current } }));
    document.querySelectorAll('[ref="cartBubbleCount"]').forEach((node) => { node.textContent = String(current.items.length); });
    document.querySelectorAll('[ref="cartBubble"]').forEach((node) => { node.classList.toggle('visually-hidden', current.items.length === 0); });
  }

  async function refresh(current) {
    const sections = [...new Set([...document.querySelectorAll('cart-items-component')].map((node) => node.dataset.sectionId).filter(Boolean))];
    for (const id of sections) {
      const path = new URL(root, window.location.origin);
      path.searchParams.set('section_id', id);
      const response = await transport(path.href, { credentials: 'same-origin', cache: 'no-store' });
      if (!response.ok) throw new Error(msg('error'));
      const parsed = new DOMParser().parseFromString(await response.text(), 'text/html');
      const replacements = [...parsed.querySelectorAll('cart-items-component')];
      document.querySelectorAll('cart-items-component').forEach((node) => {
        if (node.dataset.sectionId !== id) return;
        const replacement = replacements.find((candidate) => candidate.dataset.sectionId === id && candidate.hasAttribute('data-drawer') === node.hasAttribute('data-drawer'));
        if (replacement) node.innerHTML = replacement.innerHTML;
      });
      document.querySelectorAll('.cart__summary').forEach((node) => {
        if (node.closest('cart-items-component')) return;
        const replacement = parsed.querySelector('.cart__summary');
        if (replacement && id.includes('main')) node.innerHTML = replacement.innerHTML;
      });
    }
    announce(current);
  }

  function show(text) {
    if (!notice?.isConnected) {
      notice = document.createElement('p');
      notice.className = 'milfios-metragem-notice';
      notice.setAttribute('role', 'alert');
      const target = document.querySelector('main .cart__ctas, main .cart-form, main');
      (target || document.body).prepend(notice);
    }
    const review = text === msg('review');
    notice.classList.toggle('milfios-metragem-notice--review', review);
    notice.replaceChildren();
    if (review) {
      text.split(/(<strong>.*?<\/strong>)/g).forEach((part) => {
        if (part.startsWith('<strong>') && part.endsWith('</strong>')) {
          const emphasis = document.createElement('strong');
          emphasis.textContent = part.slice(8, -9);
          notice.append(emphasis);
        } else {
          notice.append(document.createTextNode(part));
        }
      });
    } else {
      notice.textContent = text;
    }
    notice.scrollIntoView?.({ behavior: 'smooth', block: 'center' });
  }

  function productInit(selector) {
    if (controllers.has(selector)) return;
    const scope = selector.closest('product-form-component') || selector.parentElement;
    const query = (value) => scope.querySelector(value);
    scope.querySelectorAll('add-to-cart-component, .accelerated-checkout-block').forEach((node) => { node.style.setProperty('display', 'none', 'important'); });
    const button = query('#milfios-add-btn');
    const input = query('#milfios-input-display');
    if (!button || !input) return;
    const label = query('#milfios-add-btn-text');
    const minus = query('#milfios-minus');
    const plus = query('#milfios-plus');
    const native = query('#milfios-qty-native');
    const property = query('#milfios-prop-metragem');
    const warning = query('#milfios-estoque-aviso');
    const shortcuts = scope.querySelectorAll('.milfios-atalho');
    let units = 5;
    let inCart = 0;
    let checking = true;
    let adding = false;
    let stock = { inventory: number(selector.dataset.estoque), tracked: selector.dataset.tracked === 'true', policy: selector.dataset.policy, available: true };
    let unitPrice = number(selector.dataset.price) * (1 - (number(selector.dataset.desconto) || 0) / 100);
    const variantId = () => selector.dataset.variantId;
    const maximum = () => { const value = limit(stock); return value === null ? Infinity : Math.max(0, value - inCart); };
    const render = () => {
      const max = maximum();
      units = Math.min(Math.max(5, units), max);
      if (!Number.isFinite(units)) units = 5;
      const locked = checking || adding || max < 1 || (!inCart && max < 5) || !stock.available;
      input.value = fmt(units / 5);
      native.value = String(units);
      if (property) property.value = meters(units);
      query('#milfios-total').textContent = (Math.round(unitPrice * units) / 100).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
      minus.disabled = locked || units <= 5;
      plus.disabled = locked || units >= max;
      button.disabled = locked;
      input.disabled = checking || adding;
      shortcuts.forEach((node) => { node.disabled = locked || number(node.dataset.metros) * 5 > max; node.classList.toggle('active', number(node.dataset.metros) * 5 === units); });
      warning.textContent = max < 1 ? msg('stock_in_cart') : (units >= max ? msg('maximum') + ' ' + fmt(max / 5) + ' m' : '');
    };
    const parseInput = () => { const value = number(input.value); units = Number.isFinite(value) ? Math.max(5, Math.round(value * 5)) : 5; render(); };
    const reload = async (current) => {
      const id = variantId();
      const [fresh, currentCart] = await Promise.all([product(selector.dataset.productUrl, id), current ? Promise.resolve(current) : cart()]);
      if (id !== variantId() || !selector.isConnected) return;
      stock = fresh;
      selector.dataset.estoque = String(fresh.inventory);
      inCart = totalFor(currentCart, id);
      const existing = currentCart.items.find((item) => String(item.variant_id) === String(id));
      unitPrice = existing?.final_price ?? fresh.price * (1 - (number(selector.dataset.desconto) || 0) / 100);
      query('#milfios-preco-metro').textContent = (Math.round(unitPrice * 5) / 100).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
      checking = false;
      render();
    };
    controllers.set(selector, { units: () => units, unitPrice: () => unitPrice, reload });
    meterVariants.add(String(variantId()));
    minus.addEventListener('click', () => { units -= 1; render(); });
    plus.addEventListener('click', () => { units += 1; render(); });
    shortcuts.forEach((node) => node.addEventListener('click', () => { units = Math.round(number(node.dataset.metros) * 5); render(); }));
    input.addEventListener('blur', parseInput);
    input.addEventListener('keydown', (event) => { if (event.key === 'Enter') { event.preventDefault(); input.blur(); } });
    button.addEventListener('click', async () => {
      if (adding || checking || pending || interactionLocks) return;
      parseInput();
      adding = true;
      lock(true);
      label.textContent = msg('adding');
      render();
      try {
        const properties = {};
        new FormData(scope.querySelector('form')).forEach((value, key) => {
          const match = key.match(/^properties\[(.+)\]$/);
          if (match && match[1] !== 'Metragem' && typeof value === 'string') properties[match[1]] = value;
        });
        const result = await add({ variantId: variantId(), url: selector.dataset.productUrl, units, properties });
        await refresh(result.cart);
        await reload(result.cart);
        if (result.adjusted) show(msg('review'));
        if (result.added > 0) document.querySelector('[data-testid="cart-drawer-trigger"]')?.click();
        label.textContent = result.added > 0 ? msg('added') : msg('add');
      } catch (error) {
        if (error.stock) { stock = error.stock; inCart = totalFor(error.cart, variantId()); }
        warning.textContent = error.message || msg('error');
        show(error.message || msg('error'));
        label.textContent = msg('add');
      } finally {
        adding = false;
        lock(false);
        render();
        setTimeout(() => { label.textContent = msg('add'); }, 1500);
      }
    });
    render();
    reload().catch(() => { checking = false; stock.available = false; render(); warning.textContent = msg('error'); });
  }

  function modal() {
    if (dialog?.isConnected) return dialog;
    dialog = document.createElement('dialog');
    dialog.className = 'milfios-metragem-dialog';
    const title = document.createElement('h2');
    title.id = 'milfios-metragem-dialog-title';
    title.textContent = msg('attention');
    dialog.setAttribute('aria-labelledby', title.id);
    const info = document.createElement('p');
    info.textContent = msg('checkout_info');
    const whole = document.createElement('p');
    whole.textContent = msg('whole_fabric');
    const confirm = document.createElement('button');
    confirm.type = 'button';
    confirm.className = 'button milfios-metragem-confirm';
    confirm.textContent = msg('continue');
    const close = document.createElement('button');
    close.type = 'button';
    close.className = 'button button-secondary';
    close.textContent = msg('back');
    close.addEventListener('click', () => dialog.close());
    dialog.addEventListener('cancel', (event) => { if (pending || interactionLocks) event.preventDefault(); });
    confirm.addEventListener('click', async () => {
      if (pending || interactionLocks) return;
      lock(true);
      confirm.disabled = true;
      close.disabled = true;
      confirm.textContent = msg('checking');
      try {
        const result = await check();
        if (result.adjusted || result.belowMinimum || !result.cart.items.length) {
          await refresh(result.cart);
          dialog.close();
          show(result.belowMinimum ? msg('minimum_review') : msg('review'));
        } else {
          window.location.assign(root + 'checkout');
        }
      } catch (error) {
        dialog.close();
        show(error.message || msg('error'));
      } finally {
        lock(false);
        confirm.disabled = false;
        close.disabled = false;
        confirm.textContent = msg('continue');
      }
    });
    dialog.append(title, info, whole, confirm, close);
    document.body.append(dialog);
    return dialog;
  }

  function mount() {
    document.querySelectorAll('#milfios-selector').forEach(productInit);
    document.querySelectorAll('.milfios-cart-metragem').forEach((node) => {
      meterVariants.add(String(node.dataset.variantId));
      const units = Number(node.dataset.quantity);
      node.querySelector('.milfios-cart-minus').disabled = units <= 5;
      const maximum = node.dataset.tracked === 'true' && node.dataset.policy === 'deny' ? Math.max(0, Number(node.dataset.estoque)) : Infinity;
      node.querySelector('.milfios-cart-plus').disabled = units >= maximum;
    });
  }

  function start() {
    mount();
    let scheduled = false;
    new MutationObserver(() => {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(() => { scheduled = false; mount(); });
    }).observe(document.body, { childList: true, subtree: true });
    document.addEventListener('click', async (event) => {
      const target = event.target.closest?.('button, a');
      if (!target) return;
      const step = target.matches('.milfios-cart-plus') ? 1 : target.matches('.milfios-cart-minus') ? -1 : 0;
      if (step) {
        event.preventDefault();
        event.stopImmediatePropagation();
        if (pending || interactionLocks || target.disabled) return;
        const selector = target.closest('.milfios-cart-metragem');
        lock(true);
        try {
          const result = await change(selector.dataset.key, Math.max(5, Number(selector.dataset.quantity) + step));
          await refresh(result.cart);
          if (result.adjusted) show(msg('review'));
        } catch (error) {
          try { await refresh(await cart()); } catch (_) {}
          show(error.message || msg('error'));
        } finally {
          lock(false);
        }
      } else if (target.matches('[name="checkout"], .milfios-btn-finalizar') || (target.tagName === 'A' && new URL(target.href, window.location.origin).pathname.replace(/\/$/, '') === root.replace(/\/$/, '') + '/checkout')) {
        event.preventDefault();
        event.stopImmediatePropagation();
        if (!pending && !interactionLocks) modal().showModal();
      } else if ((pending || interactionLocks) && target.closest('.cart-form, .cart__ctas, cart-items-component')) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
    }, true);
    document.addEventListener('submit', (event) => {
      if (event.target.matches('form.cart-form') && event.submitter?.name === 'checkout') {
        event.preventDefault();
        event.stopImmediatePropagation();
        if (!pending && !interactionLocks) modal().showModal();
      }
      if (event.target.querySelector('#milfios-selector')) {
        event.preventDefault();
        event.stopImmediatePropagation();
        event.target.querySelector('#milfios-add-btn')?.click();
      }
    }, true);
    document.addEventListener('milfios:cart', (event) => {
      document.querySelectorAll('#milfios-selector').forEach((selector) => {
        controllers.get(selector)?.reload(event.detail.cart).catch(() => {});
      });
    });
    document.addEventListener('cart:update', () => {
      document.querySelectorAll('#milfios-selector').forEach((selector) => {
        controllers.get(selector)?.reload().catch(() => {});
      });
    });
    if (document.querySelector('.milfios-cart-metragem[data-needs-normalize="true"]')) {
      reconcile().then(refresh).catch(() => show(msg('error')));
    }
    const rewrite = (value) => {
      try {
        const path = new URL(String(value), window.location.origin);
        if (!path.pathname.includes('/apps/cotafrete/get_rates')) return value;
        const selector = [...document.querySelectorAll('#milfios-selector')].find((node) => node.getClientRects().length);
        const controller = controllers.get(selector);
        if (!controller) return value;
        path.searchParams.set('quantity', String(controller.units()));
        path.searchParams.set('qty', String(controller.units()));
        path.searchParams.set('total_value', String(Math.round(controller.unitPrice() * controller.units())));
        return path.href;
      } catch (_) { return value; }
    };
    const previousFetch = window.fetch;
    window.fetch = function (resource, options) {
      if (resource instanceof Request) {
        const path = rewrite(resource.url);
        if (path !== resource.url) resource = new Request(path, resource);
      } else resource = rewrite(resource);
      return previousFetch.call(this, resource, options);
    };
    const previousOpen = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function () { arguments[1] = rewrite(arguments[1]); return previousOpen.apply(this, arguments); };
  }

  window.MilfiosMetragem = Object.freeze({ add, change, check, reconcile, cart, meters });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();

